import ISuggestionSource from "./ISuggestionSource";
import {normalizeString} from "../../../helpers";

export type Item = {
    id: number|string,
    group?: string, // deprecated
    group2?: string, // deprecated
    groups?: string[],
    keywords?: string[],
    values?: string[],
    item: string,
}
type SearchableItem = {searchable: string, item: Item};

export default class ItemsSuggestionSource implements ISuggestionSource {

    private items: SearchableItem[] = [];
    private maxResultsCount = 10;

    public setMaxResults(maxResultsCount: number) {
        this.maxResultsCount = maxResultsCount;
    }

    private static clearString(s: string): string {
        return normalizeString(s).replace(/[\/()#."]/, '').replace(/ +/, ' ');
    }

    private static matchStringsSequence(query: string, searchable: string): boolean {
        return searchable.indexOf(query) > -1;
    }

    private static matchWordsParts(query: string, searchable: string): boolean {
        const words = searchable.split(' ');
        return query.split(' ').every(key => words.some(w => w.indexOf(key) === 0));
    }

    constructor(
        items: Item[]
    ) {
        this.setItems(items);
    }

    public setItems(items: Item[]): void {
        this.items = items.map(
            (i) => {
                const keywords = [i.item];
                keywords.push(i.group || '');
                keywords.push(...(i.groups || []));
                keywords.push(...(i.keywords || []));

                const searchable = keywords.filter(t => t).join(' ');
                return {
                    searchable: ItemsSuggestionSource.clearString(searchable),
                    item: i,
                };
            }
        );
    }

    public setMaxResultsCount(n: number): void {
        this.maxResultsCount = n<1 ? 10 : n;
    }

    public search(query: string, onResult: (result: any[])=>any): void {
        const normalizedQuery = ItemsSuggestionSource.clearString(query);
        const results = this.items
            .filter(i => ItemsSuggestionSource.matchWordsParts(normalizedQuery, i.searchable))
            .sort((a, b) => {
                const relevanceA = this.searchRelevance(a, normalizedQuery);
                const relevanceB = this.searchRelevance(b, normalizedQuery);
                if (relevanceA > relevanceB) {
                    return -1;
                }
                if (relevanceA < relevanceB) {
                    return 1;
                }

                const groupA = a.item.groups?.[0] || a.item.group || '';
                const groupB = b.item.groups?.[0] || b.item.group || '';

                return (a.item+groupA).localeCompare(b.item+groupB);
            })
            .map(i => (i.item))
            .slice(0, this.maxResultsCount);

        onResult(results);
    }

    /**
     * Compute result relevance (first sorting criteria)
     * Bigger is better, the result will appear more on the top of results
     *
     * @param item
     * @param normalizedQuery
     * @private
     */
    private searchRelevance(item: SearchableItem, normalizedQuery: string): number {
        let relevance = 0;

        const group = (item.item.groups?.[0] || item.item.group);
        // item with same name of group and item =>  Nymburk (Nymburk)
        if (item.item.item.toLowerCase() === group?.toLowerCase()) {
            relevance++;
        }

        // normalized match of item, query dvory => Dvory (Nymburk)
        if (item.searchable.indexOf(normalizedQuery) === 0) {
            relevance++;
        }

        return relevance;
    }
}